export const connectNode = 'https://fitt-bd.org/impact_db_backend/' //'https://rc-fittbd.partners.org/impact_db_backend/' //'https://zhpysch9.mgb.org/impact_db_backend/'
export const baseURL = 'https://fitt-bd.org/'

